"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-options" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = ["value"];
const _hoisted_5 = ["data-tooltip"];
const _hoisted_6 = {
    key: 1,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerinput.include, (included) => {
                return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                    key: included,
                    class: "form-inline d-flex align-items-center mb-2"
                }, [
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.unit) = $event)),
                        value: included,
                        class: "form-radio mr-2"
                    }, null, 8, _hoisted_4), [
                        [vue_1.vModelRadio, _ctx.unit]
                    ]),
                    (0, vue_1.createElementVNode)("i", {
                        "data-tooltip": included,
                        class: (0, vue_1.normalizeClass)('resource_icon mr-2 tooltip tooltip-bottom resource_icon--' + included)
                    }, null, 10, _hoisted_5),
                    (0, vue_1.createTextVNode)(" " + (0, vue_1.toDisplayString)(_ctx.$t(included)), 1)
                ])), [
                    [_directive_trim_whitespace]
                ]);
            }), 128))
        ]),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    onClick: _ctx.saveData,
                    title: _ctx.playerinput.buttonLabel
                }, null, 8, ["onClick", "title"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
